import { z } from 'zod'
import { isIsoDate, startOfMonth, todayIso } from '../../lib/dates'
import type { DateRange } from '../../ui/date-range'

const isoDate = z
  .string()
  .refine((v) => isIsoDate(v))
  .optional()
  .catch(undefined)
const uuid = z.uuid().optional().catch(undefined)

/**
 * Reports › Tasks keeps its filters in the URL (shareable, back-button safe): the period and the
 * team or customer it is narrowed to. Invalid values fall back to the defaults.
 */
export const taskReportSearchSchema = z.object({
  from: isoDate,
  to: isoDate,
  teamId: uuid,
  customerId: uuid,
})

export type TaskReportSearch = z.infer<typeof taskReportSearchSchema>

/**
 * The period asked for: this month to date (in Muscat) by default. Not the whole month, so work due
 * later this month does not count against on-time delivery before its date has come.
 */
export function taskReportRange(search: TaskReportSearch, today: string = todayIso()): DateRange {
  return { from: search.from ?? startOfMonth(today), to: search.to ?? today }
}
